// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"042046a7","167":"170dc2f4","281":"ed4c38d3","415":"c906d761","567":"85d1269a","746":"011cce11","845":"433199d6"}[chunkId] + ".chunk.js";
};